import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["component", "children", "definitionParams"];
import { useEffect, useMemo } from 'react';
import UIEmbeddedComponentHOC from '../../iframe-wrapper/embed/UIEmbeddedComponent';
import { useNavComponentManager } from '../hooks';
import { useCreateNavComponentManager } from '../hooks/internal';
import { NavigationComponentContext } from './internal';

// Temporarily re-exporting to maintain backwards compatilbility, use 'navigation-components/consumer/models' instead.
import { jsx as _jsx } from "react/jsx-runtime";
const _Provider = ({
  definition: applyDefinition,
  children,
  definitionParams = {},
  embeddedContext,
  onReady,
  enableStandaloneMode,
  handshake = {
    metricsStartTime: 0
  }
}) => {
  const definition = applyDefinition(definitionParams);
  if (enableStandaloneMode) {
    definition.deferLoading = false;
  }
  const manager = useCreateNavComponentManager({
    definition: definition,
    embeddedContext,
    handshake
  });
  const {
    getComponentReadyMsg
  } = manager;
  useEffect(() => {
    onReady(getComponentReadyMsg());
  }, [getComponentReadyMsg, onReady]);
  return /*#__PURE__*/_jsx(NavigationComponentContext.Provider, {
    value: manager,
    children: children
  });
};
const Provider = props => {
  const {
    enableStandaloneMode
  } = props;
  const ProxyComponent = useMemo(() => UIEmbeddedComponentHOC(_Provider, {
    enableTopLevelEmbedForTestOnly: enableStandaloneMode,
    enableTopLevelEmbed: enableStandaloneMode
  }), [enableStandaloneMode]);
  return /*#__PURE__*/_jsx(ProxyComponent, Object.assign({}, props));
};
const Renderer = ({
  component: Component,
  children
}) => {
  const {
    props,
    state
  } = useNavComponentManager();
  return /*#__PURE__*/_jsx(Component, Object.assign({
    state: state
  }, props, {
    children: children
  }));
};
export const NavigationComponent = _ref => {
  let {
      component,
      children,
      definitionParams
    } = _ref,
    providerProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Provider, Object.assign({
    definitionParams: definitionParams
  }, providerProps, {
    children: /*#__PURE__*/_jsx(Renderer, Object.assign({
      definitionParams: definitionParams,
      component: component
    }, providerProps, {
      children: children
    }))
  }));
};
NavigationComponent.Provider = Provider;
NavigationComponent.Renderer = Renderer;